// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_b6-0";
export var actionModalContentContainer = "_b6-1";
export var createTagButton = "_b6-2";
export var footerContainer = "_b6-7";
export var fullWidthDivider = "_b6-3";
export var hasCreateTagButton = "_b6-4";
export var noCreateTagButton = "_b6-5";
export var tagsContainer = "_b6-6";
export var tagsModalContentContainer = "_b6-8";